currentHash = undefined;
pu = undefined;
is_ie = isIE();
global_debug = false;
toolbar = undefined;
fmBroker = undefined;
registry = {};

setupContextualHelp = function () {
    var show_tooltip =
        function () {
            var parent = $(this).parents('.ch_anchor');
            if (parent.length) {
                parent.find('.ch')
                    .css('left', 560)
                    .css('top', parent.position().bottom)
                    .css('z-index', 2000)
                    .each(function() {
                        $(this).html(_T(this.id));
                    })
                    .show();
            }
        };
    var hide_tooltip =
        function () {
            $(this).parents('.ch_anchor').find('.ch').hide();
        };

    $(document)
        .on('focus', 'input, textarea, select', show_tooltip)
        .on('blur', 'input, textarea, select', hide_tooltip)

        .on('click, mouseenter', 'input:checkbox, input:radio', show_tooltip)
        .on('mouseout', 'input:checkbox, input:radio', hide_tooltip)

        .on('mouseover', '.ch_target', show_tooltip)
        .on('mouseenter', 'div.std-selector, div.std-selector *, .ch_target', show_tooltip)
        .on('mouseout', 'div.std-selector, div.std-selector *, .ch_target', hide_tooltip);


    // jQuery UI Tooltip
    $(document).tooltip({
        items: '.jtooltip',
        tooltipClass: 'ui-widget-tooltip',
        track: true,
        content: function() {
            return $('#' + $(this).attr('id') + '_tooltip').html();
        }
    });
};

getDeleteItemConfirm = function (_warning, _url, _success_url) {
    return function() {
               if (confirm(_warning) ) {
                   $.ajax(_url, { type: 'DELETE' })
                       .done(function() { doLoad(_success_url); })
                       .fail(function(_request, _error) {
                           if (_request.responseText) {
                               alert(_request.responseText);
                           }
                       });
               }
            }
};

$( document ).ready( function() { checkHash(); } );

$( window ).bind( 'hashchange', function( _e ) {
	checkHash();
} );

checkHash = function () {
	var hash = window.location.hash.slice( window.location.hash.indexOf( '#' ) + 1 );
	log.debug( 'hash: Window is: ' + window.location.hash + ' (' + hash + ')' );
	log.debug( 'hash: Current is: ' + currentHash );

    if(hash === '_=_'){
        hash = '';
    }

	if( hash ) {
		if( hash.charAt( 0 ) == '/' ) {
			if( currentHash == undefined ) {
				log.debug( 'hash: Redirecting to ' + hash );
				window.location = hash;
			} else {
				if( currentHash != hash ) {
					log.debug( 'hash: Recalling ' + hash );
					doLoad( hash );
				}
			}
		}
	} else {
		if( !currentHash ) {
            log.debug('hash: first')
			init();
		} else {
			log.debug( 'hash: Recalling original' );
            doLoad( window.location.pathname );
		}
	}
    return false;
};

gNotifier = {
    buffer:[],
    settings:{autoHide:false},
    create:function (_id, _settings) {
        if (!_settings) _settings = {};
        this.max = 1;
        this.settings = _settings;
        this.settings.container.append('<div id="gnotifier"></div>');
    },
    display:function (_text) {
        this.buffer.push(_text);
        this.update();
    },
    update:function () {
        if (this.buffer.length > this.max) this.buffer.splice(0, ( this.buffer.length - this.max ));
        $('#gnotifier').html('<p>' + this.buffer.join('<br/>') + '</p>');
        $('#gnotifier').css('font-weight', 'bold');
        this.show(true);
        this.interval = setTimeout("$('#gnotifier').css('font-weight', 'normal')", 2000);
        if (this.settings.autoHide) this.interval = setTimeout('gNotifier.show( false )', 2000);
    },
    show:function (_show) {
        //$( '#gnotifier' ).show();
        toolbar.show('notifier');
    },
    hide:function () {
        //$( '#gnotifier' ).hide();
        toolbar.hide('notifier');
    },
    destroy:function () {
        this.interval = clearInterval(this.interval);
        $('#gnotifier').remove();
    },
    saving:function () {
        this.display(_T('persistor saving...'));
    },
    saved:function () {
        var d = new Date();
        this.display(_T('persistor saved on %s', padNumber(d.getHours(), 2) + ':' + padNumber(d.getMinutes(), 2) + ':' + padNumber(d.getSeconds(), 2)));
    }
};

FieldManagerBroker = function () {};
FieldManagerBroker.prototype = {
    create: function(_settings) {
        this.settings = _settings;
        this.managers = {};
    },
    register: function(_manager) {
        this.managers[_manager.manager.id] = _manager.manager;
    },
    get: function(_id) {
        return this.managers[_id];
    },
    unload: function(_id) {
        var manager = this.managers[_id];
        if (manager) {
            manager.destroy();
            delete(this.managers[_id]);
        }
    }
};

persistorObject = function () {
    this.active= true
};
persistorObject.prototype = {

	create: function( _settings ) {
		this.container = $( '<div id="persistor" ></div>' );
		$( 'body' ).append( this.container );
	},
	add: function( _element ) {
		this.container.append( _element );
	},
	switchOn: function() {
        this.active= true;
        this.container.show();
    },
	switchOff: function() {
        this.active= false;
        this.container.hide();
    },
    hasActivity: function() {
        return this.active && (app.player.hasActivity()) || app.uploader.hasActivity()
    }
};

toolbarObject = function toolbarObject() {};
toolbarObject.prototype = {

	create: function() {
		this.container = $( '<div style="clear:both"></div>' );
		this.ul = $( '<ul id="main_toolbar"></ul>' );
		this.container.append( this.ul );

    	this.controls = [];
	},
	add: function( _id, _holder, _control ) {

		var cd = null;
		if( _control ) {
			cd = $( '<div class="toolbar_container"></div>' ).hide();
			cd.append( _control );
			this.container.append( cd );
		}

		var li = $( '<li></li>' );
		var d = $( '<div style="margin-right:20px;position:relative;width:100%"></div>' );
		if( cd ) {
			var open = $( '<img class="toggle_' + _id + ' open_'+_id+'" style="position: absolute; right: 0px; top: 0" src="/images/default/icon_spacer.gif" />' );
			open.click( function() {
                if( cd.open ) {
                    open.attr('class','toggle_' + _id + ' open_' + _id );
                    cd.hide();
                    cd.open = false;
                } else {
                    open.attr('class', 'toggle_' + _id + ' close_' + _id);
                    cd.show();
                    cd.open = true;
                };
                return false;
            });
			d.append( open );
		}
		d.append( _holder );
		li.append( d );
		this.ul.append( li );
		this.controls[ _id ] = { li: li, cd: cd, h: _holder };
	},
	get: function( _id ) {
		return this.controls[ _id ];
	},
	hide: function( _id ) {
		this.get( _id ).li.hide();
	},
	show: function( _id ) {
		this.get( _id ).li.show();
	},
	notify: function( _id, _message ) {
		this.get( _id ).h.html( _message );
	}

};

init = function () {
    if (app.uploader.hasActivity()) {
        return;
    }

	log.debug('Init persistor toolbar');

	var g_container = $( '<div></div>' );
	gNotifier.create( 'notifier', { container: g_container } );

	toolbar = new toolbarObject();
	toolbar.create();

	persist = new persistorObject();
	persist.create();
	persist.add( toolbar.container );

    fmBroker = new FieldManagerBroker();
    fmBroker.create();

	toolbar.add( 'notifier', g_container, null );
	toolbar.hide( 'notifier' );

	log.debug( 'Adding click behaviour' );

    $('#page').on('click', 'a', function(_event) {
        if(_event.ctrlKey || !persist.hasActivity()) {
            return;
        }

        var target = $(_event.currentTarget);

        if( $(target).is('a') ) {
            var url = $( target ).attr( 'href' );
            if( !url ||
                (url == '#') ||
                 ($( target ).attr( 'rel' ) == 'script')) {

                return false;
            }

            if( ($( target ).attr( 'rel' ) == 'external') ||
                 $( target ).hasClass('ignore-persistor')) {

                window.location = url;
                return false;
            }

            log.debug( 'Click on link: ' + url );
            doLoad( url );

            return false;
        }
    } );

	toolbar.add( 'debug', $( '<div></div>' ).attr( 'id', 'pdebug' ) );
};

doReload = function () {
    if (persist.hasActivity()) {
        doLoad(location.hash ? location.hash : location.pathname);
    } else {
        location.reload();
    }
};

doLoad = function ( _page, _parameters, _method ) {
    if (!persist.hasActivity()) {
        location.href = _page;
        return;
    }

    currentHash = _page;
	if( !is_ie ) { // Internet Explorer reset History and breaks click behaviour
		window.location.hash = _page;
	}

    $.ajax({
        type: _method?_method:'GET',
        url: _page,
        data: _parameters,
        headers: {'x-mx2-layout': 'page-content'},
        dataTypeString: 'html'
    })
    .done(function( _data ) {
        if (app) {
            app.bus.$off('sidebar.set.active');
            app.bus.$off('my.account.set.active');
        }

        $( '#page' ).html( _data );

        $( '#spinner' ).hide();
        $( '#page' ).show();

        postRender();
    })
    .fail(function(_xhr, _ajaxOptions, _thrownError) {
        log.error('fail loading: ' + _page + ' -> (' + _xhr.status + ')' + _thrownError);
    });
};

loginAsUser = function (_login) {
    $.ajax('/sessions/change', {type: 'POST', async: false, data: JSON.stringify({'login': _login.trim()})})
        .done(function () {
            location.href = '/';
        })
        .fail(function () {
            alert(_T('problem changing user'));
        });
};
